<template lang="pug">
#cadastrar-monitoramento
    BaseHeader(
        :titulo='$t("mensagens.monitoramentoAgricola.novoMonitoramento.baseHeader.titulo")',
        :voltarPara='voltarPara',
        icon='mdi mdi-play',
        :btnTexto='$t("mensagens.monitoramentoAgricola.novoMonitoramento.baseHeader.botao")',
        ,
        :exibeBotao='true',
        :desabilitaBotao='desabilitaBotao',
        @btnHeaderClicado='handleIniciarMonitoramento'
    )

    FiltrarTerritorioMonitoramento(
        :isMonitoramentoSocioambiental='false',
        @atualizar-filtro='atualizarFiltroAvancado'
    )
    TabelaSelecionarTerritorioMonitoramento(
        v-loading='buscandoTerritorios',
        ref='tableComponent',
        @rows-selecionados-changed='handleRowsSelecionadosChanged',
        :dadosTabelaMonitoramento='dadosTabelaMonitoramento',
        :paginacao='paginacao',
        tipo='AGRICOLA',
        @atualizar-pagina='atualizarPagina',
        @atualizar-tabela='buscarTerritorios'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import FiltrarTerritorioMonitoramento from '@/components/monitoramento/FiltrarTerritorioMonitoramento';
import TabelaSelecionarTerritorioMonitoramento from '@/components/monitoramento/TabelaSelecionarTerritorioMonitoramento.vue';
import territorioService from '@/services/TerritorioService';
export default {
    name: 'CadastrarMonitoramentoAgricola',
    components: {
        BaseHeader,
        FiltrarTerritorioMonitoramento,
        TabelaSelecionarTerritorioMonitoramento
    },
    data() {
        return {
            desabilitaBotao: true,
            voltarPara: {
                route: 'MonitoramentoAgricola'
            },
            filtros: {
                idCulturas: [],
                idSafras: [],
                possuiAlertas: null,
                idRepresentantes: [],
                idTerritorios: []
            },
            paginacao: {
                pagina: 0,
                ordenacao: 'nome,asc',
                tamanho: 20
            },
            dadosTabelaMonitoramento: {
                itens: [],
                paginaAtual: 0,
                totalItens: 0
            },

            buscandoTerritorios: true,
            voltarHome: false
        };
    },
    watch: {
        filtros: function () {
            this.buscarTerritorios();
        }
    },

    mounted() {
        this.buscarTerritorios();
        this.validarRotaComParametro();
    },
    methods: {
        handleIniciarMonitoramento() {
            this.$refs.tableComponent.iniciarMonitoramento();
        },
        handleRowsSelecionadosChanged(rowsSelecionadas) {
            this.desabilitaBotao = rowsSelecionadas.length === 0;
        },
        atualizarFiltroAvancado(filtros) {
            this.filtros = {
                ...this.filtros,
                ...filtros
            };
            this.filtros = filtros;
        },
        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina - 1;
            this.buscarTerritorios();
        },
        async buscarTerritorios() {
            this.buscandoTerritorios = true;
            try {
                const territorios =
                    await territorioService.findAllAgricolaFilter(
                        this.paginacao,
                        this.filtros
                    );

                this.dadosTabelaMonitoramento.itens = territorios.data.content;
                this.dadosTabelaMonitoramento.totalItens =
                    territorios.data.totalElements;
                this.dadosTabelaMonitoramento.paginaAtual =
                    territorios.data.pageable.pageNumber;
            } finally {
                this.buscandoTerritorios = false;
            }
        },
        validarRotaComParametro() {
            if (this.$route.params.valor && this.$route.params.id) {
                this.voltarPara.route = 'Home';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
#cadastrar-monitoramento {
    .box-instrucao {
        float: left;
        height: 39px;
        margin-right: 14px;
        color: #3b3b3b;
        max-width: 269px;
        font-size: 13px;
    }

    .base-monitoramento-button-container {
        button {
            height: 40px;
            display: flex;
            align-items: center;
            padding: 6px 20px;
        }
    }

    .margin-top {
        margin-top: 15px;
    }
}
</style>
